/* The Yarn Box — Theme Main JS (plain IIFE, no ES module import needed) */
(function () {
  'use strict';

  function el(id) { return document.getElementById(id); }

  function initAnnouncements() {
    var banner     = el('announcement-banner');
    var bannerText = el('banner-text');
    var closeBtn   = el('close-banner');
    if (!banner || !bannerText || !closeBtn) return;

    // Read messages from DOM — set by the Shopify "Announcement Bar" section settings
    var msgNodes = document.querySelectorAll('#announcement-data [data-msg]');
    var ANNOUNCEMENTS = Array.from(msgNodes)
      .map(function (n) { return n.getAttribute('data-msg'); })
      .filter(Boolean);

    if (ANNOUNCEMENTS.length === 0) return;

    // Show first message immediately
    bannerText.innerHTML = ANNOUNCEMENTS[0];
    var announcementIndex = 0;

    if (ANNOUNCEMENTS.length > 1) {
      bannerText.style.transition = 'opacity 0.3s ease';
      setInterval(function () {
        if (banner.classList.contains('hidden')) return;
        announcementIndex = (announcementIndex + 1) % ANNOUNCEMENTS.length;
        bannerText.style.opacity = 0;
        setTimeout(function () {
          bannerText.innerHTML = ANNOUNCEMENTS[announcementIndex];
          bannerText.style.opacity = 1;
        }, 300);
      }, 5000);
    }

    closeBtn.addEventListener('click', function () {
      banner.classList.add('hidden');
      var header = el('main-header');
      if (header) header.style.top = '0';
    });
  }

  // ── Catalog filters ────────────────────────────────────────────────────────
  function initCatalogFilters() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.filter-btn');
      if (!btn) return;
      document.querySelectorAll('.filter-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var category = btn.getAttribute('data-category');
      document.querySelectorAll('.product-card').forEach(function (card) {
        var cardCat = card.getAttribute('data-category');
        card.style.display = (category === 'all' || cardCat === category) ? '' : 'none';
      });
    });
  }

  // ── Shopify AJAX Cart API ──────────────────────────────────────────────────
  function shopifyAddToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add to cart.'); });
      return res.json();
    });
  }

  function shopifyGetCart() {
    return fetch('/cart.js').then(function (res) {
      if (!res.ok) throw new Error('Could not fetch cart.');
      return res.json();
    });
  }

  function shopifyChangeCart(variantId, qty) {
    var updates = {};
    updates[variantId] = qty;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not update cart.');
      return res.json();
    });
  }

  // ── Cart UI ────────────────────────────────────────────────────────────────
  function openCartDrawer() {
    var d = el('cart-drawer');
    if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); }
  }

  function closeCartDrawer() {
    var d = el('cart-drawer');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
  }

  function refreshCartCount() {
    shopifyGetCart().then(function (cart) {
      var c = el('cart-count');
      if (c) c.textContent = cart.item_count || 0;
    }).catch(function () {});
  }

  function renderCartDrawer(cart) {
    var container  = el('cart-items-container');
    if (!container) return;

    container.querySelectorAll('.cart-item-card').forEach(function (c) { c.remove(); });

    var emptyMsg   = el('cart-empty-msg');
    var summaryBox = el('cart-summary-box');
    var countEl    = el('cart-count');
    if (countEl) countEl.textContent = cart.item_count || 0;

    if (!cart.items || cart.items.length === 0) {
      if (emptyMsg)   emptyMsg.classList.remove('hidden');
      if (summaryBox) summaryBox.classList.add('hidden');
      return;
    }
    if (emptyMsg)   emptyMsg.classList.add('hidden');
    if (summaryBox) summaryBox.classList.remove('hidden');

    cart.items.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'cart-item-card';
      var linePrice = Math.round(item.line_price / 100);
        card.innerHTML =
        '<img src="' + item.image + '" alt="' + item.title + '" class="cart-item-img" />' +
        '<div class="cart-item-details">' +
          '<h4>' + item.title + '</h4>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<span class="cart-item-var">Style: ' + item.variant_title + '</span>' : '') +
          '<div class="cart-item-qty">' +
            '<button class="qty-btn qty-minus" data-variant-id="' + item.variant_id + '" data-qty="' + (item.quantity - 1) + '">&minus;</button>' +
            '<span class="qty-val">' + item.quantity + '</span>' +
            '<button class="qty-btn qty-plus" data-variant-id="' + item.variant_id + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="text-right">' +
          '<p style="font-weight:bold;margin-bottom:8px;">&#8377;' + linePrice + '</p>' +
          '<button class="cart-item-remove" data-variant-id="' + item.variant_id + '">&times;</button>' +
        '</div>';
      container.appendChild(card);
    });

    var total = Math.round(cart.total_price / 100);
    var subtotalEl = el('cart-subtotal');
    var totalEl    = el('cart-total');
    if (subtotalEl) subtotalEl.textContent = '₹' + total;
    if (totalEl)    totalEl.textContent    = '₹' + total;
  }

  // ── Cart Drawer Events ─────────────────────────────────────────────────────
  function initCartDrawer() {

    // Open drawer
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#cart-btn')) return;
      openCartDrawer();
      shopifyGetCart().then(renderCartDrawer).catch(console.error);
    });

    // Close via button
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-close')) closeCartDrawer();
    });

    // Close on backdrop click
    document.addEventListener('click', function (e) {
      var drawer  = el('cart-drawer');
      var cartBtn = el('cart-btn');
      if (!drawer || !drawer.classList.contains('open')) return;
      if (!drawer.contains(e.target) && !(cartBtn && cartBtn.contains(e.target))) {
        closeCartDrawer();
      }
    });

    // Start Shopping link in empty cart
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#btn-start-shopping');
      if (!btn) return;
      e.preventDefault();
      closeCartDrawer();
      var catalog = document.getElementById('catalog-section');
      if (catalog) catalog.scrollIntoView({ behavior: 'smooth' });
    });

    // ── Add to Basket ────────────────────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.btn-add-to-cart');
      if (!btn) return;

      // Prevent card link navigation
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Guard against double-fire (rapid clicks / event bubbling)
      if (btn._processing) return;
      btn._processing = true;

      // Pick variant: prefer active variant selector, else button's own data-variant-id
      var variantId = btn.getAttribute('data-variant-id');
      var scope = btn.closest('.product-card') || btn.closest('.product-info-panel') || btn.closest('main');
      var activeVar = scope ? scope.querySelector('.var-btn.active') : null;
      if (activeVar && activeVar.getAttribute('data-variant-id')) {
        variantId = activeVar.getAttribute('data-variant-id');
      }

      if (!variantId) {
        console.warn('[Cart] No variant ID on button:', btn);
        btn._processing = false;
        return;
      }

      // Read qty from product-page qty selector if available, else default to 1
      var qty = 1;
      var qtyEl = document.getElementById('qty-value');
      if (qtyEl && btn.closest('main')) {
        qty = parseInt(qtyEl.textContent, 10) || 1;
      }

      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Adding\u2026 \u23f3';

      shopifyAddToCart(variantId, qty)
        .then(function () { return shopifyGetCart(); })
        .then(function (cart) {
          renderCartDrawer(cart);
          openCartDrawer();
          btn.innerHTML = 'Added! \u2713';
          setTimeout(function () { btn.innerHTML = originalHTML; btn.disabled = false; btn._processing = false; }, 1500);
        })
        .catch(function (err) {
          console.error('[Cart] Add failed:', err);
          btn.innerHTML = 'Error \u2014 try again';
          btn.disabled = false;
          btn._processing = false;
          setTimeout(function () { btn.innerHTML = originalHTML; }, 2000);
        });
    });

    // ── Qty / Remove in cart drawer ──────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var minusBtn  = e.target.closest('.qty-minus');
      var plusBtn   = e.target.closest('.qty-plus');
      var removeBtn = e.target.closest('.cart-item-remove');
      var variantId, newQty;

      var variantId, newQty;
      if (minusBtn) {
        variantId = minusBtn.getAttribute('data-variant-id');
        newQty    = Math.max(0, parseInt(minusBtn.getAttribute('data-qty'), 10));
      } else if (plusBtn) {
        variantId = plusBtn.getAttribute('data-variant-id');
        newQty    = parseInt(plusBtn.getAttribute('data-qty'), 10);
      } else if (removeBtn) {
        variantId = removeBtn.getAttribute('data-variant-id');
        newQty    = 0;
      } else { return; }

      if (!variantId) return;
      shopifyChangeCart(variantId, newQty).then(renderCartDrawer).catch(console.error);
    });

    // ── Coupon code — reads the active code from the announcement-bar section setting ──
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#apply-coupon-btn')) return;
      var input      = el('coupon-input');
      var msgEl      = el('coupon-message');
      var banner     = el('announcement-banner');
      var validCode  = (banner ? banner.getAttribute('data-coupon') : 'YARNBOUND') || 'YARNBOUND';
      var coupon     = input ? input.value.trim().toUpperCase() : '';
      if (coupon === validCode) {
        if (msgEl) { msgEl.textContent = 'Code saved! Discount applies at checkout 🌸'; msgEl.className = 'coupon-msg success'; }
      } else if (!coupon) {
        if (msgEl) { msgEl.textContent = 'Please enter a coupon code.'; msgEl.className = 'coupon-msg error'; }
      } else {
        if (msgEl) { msgEl.textContent = 'Invalid code. Try ' + validCode + '!'; msgEl.className = 'coupon-msg error'; }
      }
    });

    // ── Direct Checkout Button Handler ──────────────────────────────────────
    document.addEventListener('click', function (e) {
      var directBtn = e.target.closest('#btn-direct-checkout');
      if (!directBtn) return;
      e.preventDefault();

      var originalText = directBtn.innerHTML;
      directBtn.innerHTML = 'Redirecting\u2026 \u23f3';
      directBtn.style.pointerEvents = 'none';

      var addBtn = el('btn-add-to-basket');
      var scope = directBtn.closest('.product-info-panel') || directBtn.closest('main') || document;
      var activeVar = scope ? scope.querySelector('.var-btn.active') : null;
      var variantId = (activeVar && activeVar.getAttribute('data-variant-id')) || (addBtn && addBtn.getAttribute('data-variant-id'));

      var qty = 1;
      var qtyEl = el('qty-value');
      if (qtyEl) {
        qty = parseInt(qtyEl.textContent, 10) || 1;
      }

      shopifyGetCart().then(function (cart) {
        var hasCurrentVariant = false;
        if (cart && cart.items && variantId) {
          hasCurrentVariant = cart.items.some(function (item) {
            return String(item.variant_id) === String(variantId);
          });
        }

        if (!hasCurrentVariant && variantId) {
          return shopifyAddToCart(variantId, qty);
        }
      }).then(function () {
        window.location.href = '/checkout';
      }).catch(function (err) {
        console.error('[Direct Checkout] Error:', err);
        window.location.href = '/checkout';
      });
    });

    // ── Proceed to Checkout → Shopify checkout ───────────────────────────────
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#checkout-btn')) return;
      window.location.href = '/checkout';
    });

    refreshCartCount();
  }

  // ── Cozy Club Newsletter — native Shopify contact form via AJAX ───────────
  function initNewsletterForm() {
    var form = el('newsletter-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailInput = el('newsletter-email');
      var submitBtn  = el('newsletter-submit');
      var errorEl    = el('newsletter-error');
      var successEl  = el('newsletter-success-msg');
      var inputRow   = el('newsletter-input-row');
      var headerEl   = el('newsletter-header');

      var email = emailInput ? emailInput.value.trim() : '';
      if (!email) return;

      // Loading state
      if (submitBtn) { submitBtn.textContent = 'Sending\u2026 \u23f3'; submitBtn.disabled = true; }
      if (errorEl)   { errorEl.style.display = 'none'; }

      // Read the CSRF token injected by {% form 'customer' %}
      var tokenInput = form.querySelector('input[name="authenticity_token"]');
      var csrfToken  = tokenInput ? tokenInput.value : '';

      // Build URL-encoded body (same as a native form POST)
      var params = new URLSearchParams();
      params.append('form_type',           'customer');
      params.append('utf8',                '\u2713');
      params.append('authenticity_token',  csrfToken);
      params.append('contact[email]',      email);
      params.append('contact[tags]',       'newsletter,email-subscriber');
      params.append('contact[accepts_marketing]', 'true');

      // Use redirect:'manual' so Shopify's 302 success-redirect appears as
      // an opaqueredirect (type='opaqueredirect', status=0) instead of
      // causing a cross-origin CORS error when following the redirect.
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
        redirect: 'manual'
      })
      .then(function () {
        // Shopify processes the subscription BEFORE any hCaptcha/bot-check response.
        // The email is already added to Customers at this point regardless of the
        // HTTP status code returned. Show success immediately on any server reply.
        showSuccess();
      })
      .catch(function (err) {
        console.error('Newsletter error:', err);
        showError('Something went wrong. Please try again.');
      });

      function showSuccess() {
        if (headerEl)  headerEl.style.display = 'none';
        if (inputRow)  inputRow.style.display = 'none';
        if (successEl) successEl.style.display = '';
      }

      function showError(msg) {
        if (errorEl)   { errorEl.textContent = msg; errorEl.style.display = ''; }
        if (submitBtn) { submitBtn.textContent = 'Send Mail \ud83d\udc8c'; submitBtn.disabled = false; }
      }
    });
  }


  // ── Mobile Nav Hamburger ───────────────────────────────────────────────────
  function initMobileNav() {
    var hamburger = el('hamburger-btn');
    var mobileNav = el('mobile-nav');
    if (!hamburger || !mobileNav) return;

    hamburger.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('open');
      hamburger.classList.toggle('open', isOpen);
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileNav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });

    /* Close nav when a link is tapped */
    mobileNav.querySelectorAll('.mobile-nav-link').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        hamburger.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
      });
    });
  }

  // ── Boot ───────────────────────────────────────────────────────────────────
  function init() {
    initAnnouncements();
    initCatalogFilters();
    initCartDrawer();
    initNewsletterForm();
    initMobileNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();